import { createI18n } from 'vue-i18n';
import BR from './lang/BR';
import IN from './lang/IN';
import PH from './lang/PH';
import ID from './lang/ID';

let channel = process.env.VUE_APP_CHANNEL;
const i18n = createI18n({
    locale: channel,
    globalInjection: true,
    escapeHtml: true,
    warnHtmlInMessage: false,   //xss警告关闭
    messages: {
        BR,
        IN,
        PH,
        ID
    }
});

export {
    i18n
};